<template>
    <div class="upload-picture-modal">
        <b-modal
            id="bill-preview-popup"
            title="Document Preview"
            size="md"
            ok-title="Download"
            cancel-title="Close"
            ok-variant="primary"
            no-close-on-backdrop
            no-close-on-esc
            @ok="onClick"
        >
            <h5>Utility Bill</h5>

            <div class="document-preview-section">
                <div
                    v-if="item && item.fileName && ext == 'pdf'"
                    class="preview-video text-center identification-section"
                >
                    <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                    <pdf
                        style="display: none"
                        :src="pdfSrc"
                        @num-pages="pageCount = new Array($event)"
                    />
                    <!-- Actual document -->
                    <pdf
                        v-for="(page, index) in pageCount"
                        :key="index"
                        :src="pdfSrc"
                        :page="index + 1"
                     
                    />
                </div>
                <div v-else>
                    <img v-authenticated-image="item.fileName" />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import pdf from 'vue-pdf'
import axios from 'axios'

export default {
    components: {
        pdf,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        item: {
            type: Object,
            default: null,
        },
    }, // End of Component > props
    data() {
        return {
            pdfSrc: process.env.VUE_APP_FILE_SERVICE_URL + this.item.fileName,
            ext:  this.item.fileName? this.item.fileName.split('.').pop() : null,
            pageCount: []
        }
    },
    methods: {
        onClick() {
              axios({
                    url: this.pdfSrc,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(response.data);
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                    const ext = (this.ext || '').toLowerCase();
                    if(ext == 'pdf') {
                        fileLink.setAttribute('download', 'bill.pdf');
                     } else if(ext == 'jpg' || ext =='png' || ext == 'jpeg'){
                        fileLink.setAttribute('download', 'bill.png');
                     } else {
                        fileLink.setAttribute('download', 'bill');
                     }
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          }
    }
}
</script>
